import React from "react";
import { Layout, Typography } from "antd";
import { withTranslation } from "react-i18next";

import { WHITE_GRAY } from "../constant/colors";

const { Footer } = Layout;
const { Text } = Typography;

const MainFooterComponent = ({ t, maxHeight }) => (
  <Footer
    style={{
      position: "sticky",
      bottom: "0",
      backgroundColor: "white",
      borderTop: `2px solid ${WHITE_GRAY}`,
      height: maxHeight,
      maxHeight,
      zIndex: 1000
    }}
  >
    <Text>{t("footer", { year: new Date().getFullYear() })}</Text>
  </Footer>
);

const MainFooter = withTranslation()(MainFooterComponent);
export { MainFooter };
